module.exports = __webpack_public_path__ + "static/UnbiasedLogo2-b90d2ccb0cab4ab52f9053f2575f516f.png";